"use strict";

export const defaults = {
  name: 'react-native-auth0',
  version: '2.17.2'
};
//# sourceMappingURL=telemetry.js.map